<template>
    <div
        :class="[
            'user-icon',
            sizeClass,
        ]"
        :style="calculateUsernameColor(user.username)">
        <span>{{ firstInitial }}</span>
    </div>
</template>

<script>
import { calculateUsernameColor, formatUserFullName } from '@utils/user-settings';

export default {
    name: 'UserIcon',
    props: {
        user: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            default: '',
        },
    },
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    computed: {
        firstInitial () {
            return formatUserFullName(this.user)
                .charAt(0)
                .toUpperCase();
        },
        sizeClass () {
            if (this.size === 'small') return 'small';

            return null;
        },
    },
    methods: {
        calculateUsernameColor,
    },
};
</script>

<style scoped lang="less">
.user-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 500;
    height: 32px;
    width: 32px;
    border-width: 1.5px;
    border-style: solid;

    &.small {
        height: 20px;
        width: 20px;
        font-size: 10px;
    }
}
</style>
